/* Forever & Ever - Scroll-driven pot rotation
   Swaps through 115 pre-rendered frames based on element scroll position */

(function() {
  'use strict';

  var TOTAL_FRAMES = 115;

  function initPotScroll() {
    var containers = document.querySelectorAll('[data-pot-scroll]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      var img = container.querySelector('.pot-scroll-img');
      if (!img) return;

      // Parse frame URLs from data attribute (JSON array set by Liquid)
      var frameUrls;
      try {
        frameUrls = JSON.parse(container.getAttribute('data-pot-frames'));
      } catch(e) {
        return;
      }
      if (!frameUrls || !frameUrls.length) return;

      // Preload all frames
      var preloaded = [];
      frameUrls.forEach(function(url) {
        var image = new Image();
        image.src = url;
        preloaded.push(image);
      });

      var currentFrame = 0;
      var ticking = false;

      function updateFrame() {
        var rect = container.getBoundingClientRect();
        var windowHeight = window.innerHeight;

        // Full scroll progress: 0 = bottom enters viewport, 1 = top leaves viewport
        var totalTravel = windowHeight + rect.height;
        var traveled = windowHeight - rect.top;
        var progress = traveled / totalTravel;

        // Offset so that progress 0.5 (element centered) = frame 0
        // Loops continuously using modulo
        var shifted = progress - 0.5;
        var frameRaw = Math.round(shifted * TOTAL_FRAMES * 2);
        var frameIndex = ((frameRaw % TOTAL_FRAMES) + TOTAL_FRAMES) % TOTAL_FRAMES;

        if (frameIndex !== currentFrame) {
          currentFrame = frameIndex;
          img.src = frameUrls[frameIndex];
        }

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateFrame);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      // Initial position
      updateFrame();
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPotScroll);
  } else {
    initPotScroll();
  }
})();
